<div class="layout-wrapper w-[100%] flex md:flex-row flex-col items-center justify-between">
  <div [ngStyle]="{'width':getSectionWidth(layouts?.[0]?.width,0)+'%'}">
    <ng-template leftResourceLayout></ng-template>
  </div>
  <div
    [ngClass]="{'md:ml-[2%] m-0':layouts.length>1}"
    [ngStyle]="{'width':getSectionWidth(layouts?.[1]?.width,1)+'%'}"
    class="mt-[1.8rem] md:mt-0">
    <ng-template middleResourceLayout></ng-template>
  </div>
  <div
    [ngClass]="{'md:ml-[2%] m-0':layouts.length>2}"
    [ngStyle]="{'width':getSectionWidth(layouts?.[2]?.width,2)+'%'}"
    class="mt-[1.8rem] md:mt-0">
    <ng-template rightResourceLayout></ng-template>
  </div>
</div>
